import { UIProvider } from '@doger/ui/provider';
import { I18nProvider } from '@doger/core/shared/i18n';

import { QueryProvider } from './providers/query.provider';

const AppProviders = ({ children }: { children: React.ReactNode }) => (
  <QueryProvider>
    <I18nProvider supportedLanguages={['en']}>
      <UIProvider supportedThemes={['dark']}>{children}</UIProvider>
    </I18nProvider>
  </QueryProvider>
);

export { AppProviders };
